import { api } from '@/lib/axios';

export type DemandeStatut = 'BROUILLON' | 'SOUMISE' | 'VALIDEE' | 'REFUSEE' | 'ANNULEE';

export interface TypeAbsence {
  id: string;
  code: string;
  libelle: string;
  remunere: boolean;
  impacte_solde_conge: boolean;
  justificatif_requis: boolean;
  pointage_type: string;
  actif: boolean;
  ordre: number;
}

export interface DemandeAbsence {
  id: string;
  employe_id: string;
  type_id: string;
  date_debut: string;
  date_fin: string;
  nb_jours: number;
  motif: string | null;
  justificatif_url: string | null;
  statut: DemandeStatut;
  valide_par_id: string | null;
  date_validation: string | null;
  commentaire_validation: string | null;
  pointages_ecrits: boolean;
  type: TypeAbsence | null;
  employe_nom: string | null;
  employe_matricule: string | null;
}

export interface DemandeInput {
  employe_id: string;
  type_id: string;
  date_debut: string;
  date_fin: string;
  motif?: string | null;
  justificatif_url?: string | null;
}

export interface SoldeConge {
  employe_id: string;
  employe_nom: string;
  employe_matricule: string;
  exercice: number;
  droits_acquis: number;
  report_n1: number;
  jours_pris: number;
  ajustement: number;
  solde: number;
}

export interface JourFerie {
  id: string;
  jour: string;
  libelle: string;
  recurrent: boolean;
}

export interface CalendrierAbsence {
  id: string;
  employe_id: string;
  employe_nom: string;
  type_code: string | null;
  type_libelle: string | null;
  pointage_type: string | null;
  statut: DemandeStatut;
  date_debut: string;
  date_fin: string;
}
export interface CalendrierResp {
  annee: number;
  mois: number;
  absences: CalendrierAbsence[];
  feries: { jour: string; libelle: string }[];
}

export interface ProvisionLigne {
  employe_id: string;
  matricule: string;
  nom: string;
  solde_jours: string;
  salaire_journalier: string;
  provision: string;
}
export interface ProvisionResp {
  exercice: number;
  compte: string;
  nb_employes: number;
  total_provision: string;
  lignes: ProvisionLigne[];
}

export async function listTypesAbsence(): Promise<TypeAbsence[]> {
  const { data } = await api.get<TypeAbsence[]>('/types-absence');
  return data;
}
export async function listDemandes(filtres?: { employe_id?: string; statut?: DemandeStatut; annee?: number; mois?: number }): Promise<DemandeAbsence[]> {
  const { data } = await api.get<DemandeAbsence[]>('/demandes-absence', { params: filtres ?? {} });
  return data;
}
export async function createDemande(payload: DemandeInput): Promise<DemandeAbsence> {
  const { data } = await api.post<DemandeAbsence>('/demandes-absence', payload);
  return data;
}
export async function updateDemande(id: string, payload: Partial<DemandeInput>): Promise<DemandeAbsence> {
  const { data } = await api.put<DemandeAbsence>(`/demandes-absence/${id}`, payload);
  return data;
}
export async function validerDemande(id: string, commentaire?: string | null): Promise<DemandeAbsence> {
  const { data } = await api.post<DemandeAbsence>(`/demandes-absence/${id}/valider`, { commentaire: commentaire ?? null });
  return data;
}
export async function refuserDemande(id: string, commentaire?: string | null): Promise<DemandeAbsence> {
  const { data } = await api.post<DemandeAbsence>(`/demandes-absence/${id}/refuser`, { commentaire: commentaire ?? null });
  return data;
}
export async function annulerDemande(id: string): Promise<DemandeAbsence> {
  const { data } = await api.post<DemandeAbsence>(`/demandes-absence/${id}/annuler`);
  return data;
}
export async function deleteDemande(id: string): Promise<void> {
  await api.delete(`/demandes-absence/${id}`);
}
export async function listSoldes(exercice: number): Promise<SoldeConge[]> {
  const { data } = await api.get<SoldeConge[]>('/soldes-conge', { params: { exercice } });
  return data;
}
export async function ajusterSolde(employeId: string, exercice: number, payload: { report_n1?: number | null; ajustement?: number | null }): Promise<SoldeConge> {
  const { data } = await api.put<SoldeConge>(`/soldes-conge/${employeId}`, payload, { params: { exercice } });
  return data;
}
export async function listFeries(annee?: number): Promise<JourFerie[]> {
  const { data } = await api.get<JourFerie[]>('/jours-feries', { params: annee ? { annee } : {} });
  return data;
}
export async function createFerie(payload: { jour: string; libelle: string; recurrent: boolean }): Promise<JourFerie> {
  const { data } = await api.post<JourFerie>('/jours-feries', payload);
  return data;
}
export async function deleteFerie(id: string): Promise<void> {
  await api.delete(`/jours-feries/${id}`);
}
export async function getCalendrier(annee: number, mois: number): Promise<CalendrierResp> {
  const { data } = await api.get<CalendrierResp>('/absences/calendrier', { params: { annee, mois } });
  return data;
}
export async function getProvision(exercice: number): Promise<ProvisionResp> {
  const { data } = await api.get<ProvisionResp>('/conges/provision', { params: { exercice } });
  return data;
}
